/* ========================================================================
 * HomeAway Bootstrap: loading.js
 * http://h.a/bootstrap3/docs/gt/javascript.html/#loading
 * ========================================================================
 * Copyright Homeaway, Inc 2005-Present. All Rights Reserved.
 * No unauthorized use of this software.
 * ======================================================================== */

import message from 'framework/modules/message';

(function (root, factory) {
    // eslint-disable-line  no-unused-expressions
    if (typeof define === 'function' && define.amd) {
        define('bootstrap-loading', [
            'jquery',
            'bootstrap-transition',
        ], factory);
    } else {
        factory(root.jQuery);
    }
})(this, function ($) {
    // LOADING PUBLIC CLASS DEFINITION
    // ==============================
    const Loading = function (element, options) {
        this.$element = $(element);
        this.element = element;
        this.options = $.extend({}, Loading.DEFAULTS, options);
    };
    let old;

    Loading.TRANSITION_DURATION = 150;

    Loading.VERSION = '3.0.0';

    Loading.prototype.generateTemplate = function () {
        const overlayClass = this.options?.showHybridLoadingScreen
            ? 'mcko-loading-overlay'
            : 'ha-loading-overlay';

        const headerHtml = this.options?.header ? this.options.header : '';

        return `<div class="${overlayClass} fade in" role="status" aria-live="polite" aria-label="${message.read(
            'loading'
        )}" aria-atomic="true">
            ${headerHtml}
            <ul>
                <li class="li1"></li>
                <li class="li2"></li>
                <li class="li3"></li>
                <li class="li4"></li>
            </ul>
        </div>`;
    };

    Loading.DEFAULTS = {
        // Default template is now generated by the generateTemplate method
        showHybridLoadingScreen: false,
    };

    Loading.prototype.getUID = function (prefix) {
        do {
            prefix += ~~(Math.random() * 1000000); // eslint-disable-line no-bitwise
        } while (document.getElementById(prefix));
        return prefix;
    };

    Loading.prototype.overlay = function () {
        if (!this.$overlay) {
            // Use the provided template from ha-loading.hbs, otherwise generate one
            const template = this.options.template || this.generateTemplate();
            this.$overlay = $(template);
        }
        return this.$overlay;
    };

    Loading.prototype.hide = function () {
        const that = this;
        const e = $.Event('hide.bs.loading');
        const $overlay = $(`#${this.$element.data('overlay-id')}`);

        this.$element.trigger(e);

        $overlay.removeClass('in');

        function removeElement() {
            // detach from parent, fire event then clean up data
            $overlay.detach().trigger('hidden.bs.loading').remove();
            that.$element.removeClass('ha-loading-container position-relative');
        }

        $.support.transition && $overlay.hasClass('fade')
            ? $overlay
                  .one('bsTransitionEnd', removeElement)
                  .emulateTransitionEnd(Loading.TRANSITION_DURATION)
            : removeElement();
    };

    Loading.prototype.show = function () {
        const e = $.Event('show.bs.loading');
        const elementPosition = this.element.style.position;
        const $overlay = this.overlay();
        const overlayId = this.getUID('loading');

        this.$element.trigger(e);

        /* if not positioning is set on the element, set it to relative so
         * the aboslutely positionted overlay with completely cover it.
         * Note: when on body, the overlay is fixed position, so this is
         * is not an issue at that time
         */
        if (elementPosition === '') {
            this.$element.addClass('position-relative');
        }

        $overlay.attr('id', overlayId).addClass('in').appendTo(this.$element);

        this.$element
            .addClass('ha-loading-container')
            .data('overlay-id', overlayId);
    };

    // LOADING PLUGIN DEFINITION
    // ========================

    function Plugin(option) {
        return this.each(function () {
            const $this = $(this);
            let data = $this.data('bs.loading');
            const options = typeof option === 'object' && option;

            if (!data) {
                $this.data('bs.loading', (data = new Loading(this, options)));
            }

            if (typeof option === 'string') {
                data[option]();
            }
        });
    }

    old = $.fn.loading;

    $.fn.loading = Plugin;
    $.fn.loading.Constructor = Loading;

    // LOADING NO CONFLICT
    // ==================
    $.fn.loading.noConflict = function () {
        $.fn.loading = old;
        return this;
    };

    // LOADING DATA-API
    // =================
    $(function () {
        $('[data-loading="show"]').each(function () {
            const $loadingOverlay = $(this);
            Plugin.call($loadingOverlay, 'show');
        });
    });
});
